<template>
  <section class="student-subscribe">
    <v-list-item @click="readAndGo">
      <v-list-item-avatar>
        <v-icon large color="primary">person_add</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle
          class="black--text"
          v-html="notification.data.text"
        />
        <v-list-item-subtitle
          ><v-icon color="grey lighten-1" class="pr-2" small>
            calendar_today
          </v-icon>
          {{
            $moment(notification.updated_at)
              .startOf('hour')
              .fromNow()
          }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="!notification.read_at">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon ripple v-on="on" @click.stop="read">
              <v-icon color="grey">remove_red_eye</v-icon>
            </v-btn>
          </template>
          <span>Mark as read</span>
        </v-tooltip>
      </v-list-item-action>
    </v-list-item>
  </section>
</template>

<script>
export default {
  name: 'StudentSubscribe',
  components: {},
  props: {
    notification: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      showAll: false
    }
  },
  mounted() {},
  computed: {},
  methods: {
    readAndGo() {
      this.$emit('readAndGo', this.notification)
    },
    read() {
      this.$emit('read', this.notification)
    }
  }
}
</script>

<style lang="scss">
.student-subscribe {
}
</style>
